var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    width: 15,
    height: 15,
    style: {
      borderColor: "rgba(187,187,187,1)",
      borderWidth: 0,
      borderStyle: "solid"
    },
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M453.8368 937.5744H180.224c-84.7872 0-153.6-68.8128-153.6-153.6V282.8288c0-84.7872 68.8128-153.6 153.6-153.6h615.6288c84.7872 0 153.6 68.8128 153.6 153.6v139.0592H88.064v362.0864c0 50.7904 41.3696 92.16 92.16 92.16h273.6128c16.9984 0 30.72 13.7216 30.72 30.72s-13.7216 30.72-30.72 30.72zM88.064 360.448h799.9488v-77.6192c0-50.7904-41.3696-92.16-92.16-92.16H180.224c-50.7904 0-92.16 41.3696-92.16 92.16v77.6192z",
    fill: "rgba(14.025,187.935,106.08,1)",
    "p-id": 12444,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.5472 290.816c-16.9984 0-30.72-13.7216-30.72-30.72V76.5952c0-16.9984 13.7216-30.72 30.72-30.72s30.72 13.7216 30.72 30.72v183.5008c0 16.9984-13.7216 30.72-30.72 30.72zM656.1792 290.816c-16.9984 0-30.72-13.7216-30.72-30.72V76.5952c0-16.9984 13.7216-30.72 30.72-30.72s30.72 13.7216 30.72 30.72v183.5008c0 16.9984-13.7216 30.72-30.72 30.72z",
    fill: "rgba(14.025,187.935,106.08,1)",
    "p-id": 12445,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.648 600.8832H200.9088c-16.9984 0-30.72-13.7216-30.72-30.72s13.7216-30.72 30.72-30.72H411.648c16.9984 0 30.72 13.7216 30.72 30.72s-13.7216 30.72-30.72 30.72zM411.648 753.664H200.9088c-16.9984 0-30.72-13.7216-30.72-30.72s13.7216-30.72 30.72-30.72H411.648c16.9984 0 30.72 13.7216 30.72 30.72s-13.7216 30.72-30.72 30.72z",
    fill: "rgba(14.025,187.935,106.08,1)",
    "p-id": 12446,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.664 552.3456c100.352 0 182.0672 81.7152 182.0672 182.0672s-81.7152 182.0672-182.0672 182.0672-182.0672-81.7152-182.0672-182.0672 81.7152-182.0672 182.0672-182.0672m0-61.44c-134.5536 0-243.5072 109.1584-243.5072 243.5072 0 134.5536 109.1584 243.5072 243.5072 243.5072s243.712-108.9536 243.712-243.5072c0-134.3488-109.1584-243.5072-243.712-243.5072z",
    fill: "rgba(14.025,187.935,106.08,1)",
    "p-id": 12447,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.544 782.7456h-122.88c-16.9984 0-30.72-13.7216-30.72-30.72v-121.0368c0-16.9984 13.7216-30.72 30.72-30.72s30.72 13.7216 30.72 30.72v90.3168h91.9552c16.9984 0 30.72 13.7216 30.72 30.72s-13.5168 30.72-30.5152 30.72z",
    fill: "rgba(14.025,187.935,106.08,1)",
    "p-id": 12448,
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentActive);
export default __webpack_public_path__ + "static/media/AppointmentActive.69436ef9.svg";
export { ForwardRef as ReactComponent };